import { Observable, Subject } from "rxjs";
import { AbstractConstructor, Constructor } from "../models";

export interface HasInitialized {
  readonly initialized: Observable<void>;
  readonly markAsInitialized: () => void;
}

export type HasInitializedCtor = Constructor<HasInitialized> & AbstractConstructor<HasInitialized>;

export function mixinHasInitialized<T extends Constructor | AbstractConstructor>(base:T) : T & HasInitializedCtor {

  return class extends base {

    private readonly _initialized = new Subject<void>();
    public readonly initialized = this._initialized.asObservable();

    public markAsInitialized(): void {
      this._initialized.next();
      this._initialized.complete();
    }
  }
}
